import { createContext, useCallback, useContext, useMemo } from 'react';

const KrCardContext = createContext(null);

export const KrCardProvider = ({ children, setGridCount, variant }) => {
  const registerGrid = useCallback(() => {
    if (!setGridCount) return;
    setGridCount((prev) => prev + 1);
  }, [setGridCount]);

  const unregisterGrid = useCallback(() => {
    if (!setGridCount) return;
    setGridCount((prev) => (prev > 0 ? prev - 1 : 0));
  }, [setGridCount]);

  const value = useMemo(() => {
    return { registerGrid, unregisterGrid, variant };
  }, [registerGrid, unregisterGrid, variant]);

  return <KrCardContext.Provider value={value}>{children}</KrCardContext.Provider>;
};

export const useKrCardContext = () => {
  return useContext(KrCardContext);
};

// Variants whose backgrounds are dark/saturated. Content nested inside these
// (badges, etc.) needs light-on-dark treatment regardless of the app theme mode.
const DARK_SURFACE_VARIANTS = new Set(['bold', 'smart']);

export const useIsOnDarkCardSurface = () => {
  const ctx = useContext(KrCardContext);
  return DARK_SURFACE_VARIANTS.has(ctx?.variant);
};
